<section class="flex min-h-[80vh] items-start justify-center px-4 pt-10 md:pt-24">
  <div hlmCard class="w-full max-w-sm">
    <div hlmCardHeader class="items-center text-center">
      <img src="../../../assets/img/HEALTH+LIFE-MED.png" width="64" class="mb-2" alt="Health+Life Logo" />
      <h1 hlmCardTitle class="text-2xl">Anmelden</h1>
      <p hlmCardDescription>Geben Sie Ihre Zugangsdaten ein, um sich im Health+Life Adminportal einzuloggen.</p>
    </div>

    <div hlmCardContent>
      <form class="flex flex-col gap-4" (ngSubmit)="onLoginWithPassword(f)" #f="ngForm">
        <!-- Email -->
        <div class="flex flex-col gap-1.5">
          <label hlmLabel for="email">E-Mail Adresse</label>
          <input
            hlmInput
            id="email"
            type="email"
            class="w-full"
            ngModel
            name="email"
            placeholder="max@beispiel.de"
            email
            required
            autocomplete="email"
            #email="ngModel"
          />
          @if (email.invalid && (email.dirty || email.touched)) {
            @if (email?.errors?.required) {
              <p class="text-destructive text-sm">Bitte geben Sie Ihre E-Mail-Adresse an.</p>
            }
            @if (email?.errors?.email) {
              <p class="text-destructive text-sm">Bitte geben Sie eine gültige E-Mail-Adresse an.</p>
            }
          }
        </div>

        <!-- Password -->
        <div class="flex flex-col gap-1.5">
          <label hlmLabel for="password">Passwort</label>
          <input
            hlmInput
            id="password"
            type="password"
            class="w-full"
            ngModel
            name="password"
            placeholder="••••••••"
            required
            autocomplete="current-password"
          />
        </div>

        <!-- Forgot password link -->
        <div class="flex justify-end">
          <a hlmBtn variant="link" class="h-auto p-0 text-sm" (click)="onForgotPassword(email.value)">
            Passwort vergessen?
          </a>
        </div>

        <!-- Submit -->
        <button hlmBtn class="w-full" type="submit" [disabled]="!f.touched || !f.valid">
          Anmelden
        </button>

        @if (devMode) {
          <div class="relative flex items-center py-2">
            <div class="border-border flex-grow border-t"></div>
            <span class="text-muted-foreground mx-3 text-xs">oder</span>
            <div class="border-border flex-grow border-t"></div>
          </div>
          <button hlmBtn variant="outline" class="w-full" type="button" (click)="onGoogleLogin()">
            Mit Google anmelden
          </button>
        }
      </form>
    </div>

    <div hlmCardFooter class="justify-center">
      <p class="text-muted-foreground text-sm">
        Noch kein Konto?
        <a hlmBtn variant="link" class="h-auto p-0 text-sm" routerLink="/signup">Registrieren</a>
      </p>
    </div>
  </div>
</section>
